import { useEffect, useRef, useState } from "react";
import type { SearchLocation } from "@puntopy/contracts";
import LocationPicker from "./LocationPicker.js";
import { Icon } from "./MarketplaceUI.js";
import { locationPoint } from "./location-point.js";

export default function SearchMapDialog({ initial, onClose, onConfirm }: { initial: SearchLocation | undefined; onClose: () => void; onConfirm: (point: SearchLocation) => void }) {
  const dialog = useRef<HTMLDialogElement>(null);
  const [selection, setSelection] = useState<SearchLocation | undefined>(initial);
  useEffect(() => {
    const element = dialog.current;
    const overflow = document.body.style.overflow;
    const previous = document.activeElement;
    document.body.style.overflow = "hidden"; element?.showModal();
    return () => { element?.close(); document.body.style.overflow = overflow; if (previous instanceof HTMLElement) previous.focus(); };
  }, []);
  return <dialog ref={dialog} className="pp-search-map-dialog" aria-labelledby="search-map-title" onCancel={(event) => { event.preventDefault(); onClose(); }}>
    <div className="mp-section-heading"><h2 id="search-map-title">¿Dónde querés buscar?</h2><button type="button" className="mp-icon-button" onClick={onClose} aria-label="Cerrar mapa"><Icon name="close" /></button></div>
    <p>Elegí un punto de Paraguay y encontrá productos cerca de esa ubicación. No necesitás estar ahí ni dar permiso de GPS.</p>
    <LocationPicker value={selection ? locationPoint(selection.lat, selection.lng) : null} initiallyOpen precision={3} onChange={(point, source) => setSelection({ ...point, source, precision: "approximate" })} />
    <button type="button" className="mp-button primary full" disabled={!selection} onClick={() => { if (selection) onConfirm(selection); }}>Buscar cerca de este punto<Icon name="search" /></button>
    <p>El punto solo se usa para esta búsqueda. No se guarda en tu perfil.</p>
  </dialog>;
}
